import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

const NAMES = { boho: "Boho Picnic", floating: "Floating Picnic", electronic: "Picnic Electronic" };

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <p className="text-earth">Chargement…</p>;

  const cards = [
    { label: "Réservations aujourd'hui", value: stats.today_count, testid: "stat-today" },
    { label: "Réservations à venir", value: stats.upcoming_count, testid: "stat-upcoming" },
    { label: "Invités à venir", value: stats.total_guests, testid: "stat-guests" },
    { label: "Revenu encaissé", value: `${stats.revenue.toFixed(0)} €`, testid: "stat-revenue" },
    { label: "Paiements en attente", value: stats.pending_payments, testid: "stat-pending" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl sm:text-4xl text-ink">Tableau de bord</h1>
      <div className="w-16 h-px bg-gold mt-4" />
      <div className="grid grid-cols-1 min-[420px]:grid-cols-2 lg:grid-cols-5 gap-4 mt-8">
        {cards.map((c) => (
          <div key={c.testid} data-testid={c.testid} className="bg-ivory border border-champagne rounded-2xl p-5">
            <p className="text-xs uppercase tracking-[0.15em] text-earth">{c.label}</p>
            <p className="font-serif text-3xl text-ink mt-2">{c.value}</p>
          </div>
        ))}
      </div>
      <h2 className="font-serif text-2xl text-ink mt-12 mb-5">Réservations récentes</h2>
      <div className="bg-ivory border border-champagne rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="recent-bookings-table">
          <thead>
            <tr className="text-left text-xs uppercase tracking-[0.12em] text-earth border-b border-champagne">
              <th className="px-5 py-4">Client</th><th className="px-5 py-4">Expérience</th>
              <th className="px-5 py-4">Date</th><th className="px-5 py-4">Invités</th>
              <th className="px-5 py-4">Montant</th><th className="px-5 py-4">Paiement</th>
            </tr>
          </thead>
          <tbody>
            {stats.recent_bookings.map((b) => (
              <tr key={b.id} className="border-b border-champagne/50 last:border-0">
                <td className="px-5 py-4 text-ink">{b.customer.name}</td>
                <td className="px-5 py-4 text-earth">{NAMES[b.experience]}{b.package ? ` (${b.package})` : ""}</td>
                <td className="px-5 py-4 text-earth">{b.date} · {b.time_slot}</td>
                <td className="px-5 py-4 text-earth">{b.guests}</td>
                <td className="px-5 py-4 text-ink">{b.amount.toFixed(0)} €</td>
                <td className="px-5 py-4">
                  <span className={`text-xs uppercase tracking-wide px-3 py-1 rounded-full ${b.payment_status === "paid" ? "bg-olive/15 text-olive-deep" : "bg-clay/10 text-clay"}`}>
                    {b.payment_status === "paid" ? "Payé" : "En attente"}
                  </span>
                </td>
              </tr>
            ))}
            {stats.recent_bookings.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-8 text-center text-earth">Aucune réservation pour le moment.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <Link data-testid="goto-bookings" to="/admin/bookings" className="inline-block mt-5 text-sm text-terracotta hover:text-clay">Voir toutes les réservations →</Link>
    </div>
  );
}
